<template>
    <Modal
        id="add-order-certificate-modal"
        ref="add-order-certificate-modal"
        v-model:open="open"
        title="add_order_certificate"
        width="xl"
        @cancel="cancel"
    >
        <FileUploadButton
            title="certificate_document"
            accept=".pdf"
            :file-name="certificateDocument.name"
            :url="certificateDocument.url"
            @submit="onCertificateDocumentUpload"
            @delete="onCertificateDocumentDelete"
        />
        <SelectField
            v-model="certificateDocument.lang"
            :label="$t('language')"
            name="certificate_lang"
            :required="true"
            :options="languages"
        />

        <template #actions>
            <button
                class="btn bg-primary-accent-500 text-white"
                @click="submit"
            >
                {{ $t('Create') }}
            </button>
        </template>
    </Modal>
</template>
<script setup lang="ts">
import { Modal } from '@src/components'
import SelectField from '@src/components/SelectField.vue'
import { Platform, PlatformCertificateDocument } from '@src/types'
import { UploadFileResponse } from '@src/utils/api/s3'
import { useLanguageStore } from '@src/utils/stores/languages'
import { useVModels } from '@vueuse/core'
import { storeToRefs } from 'pinia'
import { reactive } from 'vue'
import FileUploadButton from '../actions/FileUploadButton.vue'

const props = defineProps<{
    open: boolean
    modelValue: Platform
}>()

const emit = defineEmits([
    'update:modelValue',
    'update:open',
    'cancel',
    'submit',
])

const { open } = useVModels(props, emit)

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

const certificateDocument = reactive<PlatformCertificateDocument>({
    name: null,
    thumb_image_url: null,
    upload_key: null,
    delete: false,
    lang: 'de',
})

const cancel = () => {
    emit('cancel')
}

const submit = () => {
    emit('submit', certificateDocument)
    certificateDocument.name = null
    certificateDocument.upload_key = null
    certificateDocument.thumb_image_url = null
    certificateDocument.lang = 'de'
    certificateDocument.delete = false
}

const onCertificateDocumentUpload = (
    response: UploadFileResponse,
    fileName: string
) => {
    certificateDocument.name = fileName
    certificateDocument.upload_key = response.key
    certificateDocument.thumb_image_url = response.temp_storage_url
    certificateDocument.url = response.temp_storage_url
}

const onCertificateDocumentDelete = () => {
    certificateDocument.name = null
    certificateDocument.upload_key = null
    certificateDocument.thumb_image_url = null
    certificateDocument.lang = 'de'
    certificateDocument.delete = true
}
</script>
